import React from 'react';
import { Label } from './ui/label';

export default function ReportPeriodSelect({ id, value, onChange, disabled = false }) {
  return <div><Label htmlFor={id}>Período de notas</Label>
    <select id={id} className="w-full border rounded-md p-2 text-sm bg-white mt-1" value={value} onChange={e => onChange(e.target.value)} disabled={disabled}>
      {[10,20,30,40].map(week => <option key={week} value={String(week)}>{week} semanas</option>)}
      <option value="all">Año completo (todos los períodos)</option>
    </select>
  </div>;
}
